






import { Component, Vue } from 'vue-property-decorator';
import LoginPanel from './panels/LoginPanel.vue';
import PersonalInfoPanel from './panels/PersonalInfoPanel.vue';
import AddressPanel from './panels/AddressPanel.vue';
import PaymentInfoPanel from './panels/PaymentInfoPanel.vue';
import InterestsPanel from './panels/InterestsPanel.vue';
import QuestionsPanel from './panels/QuestionsPanel.vue';
import { NavigationTab } from '@/interfaces/registration/NavigationTab';
import { namespace } from 'vuex-class';
const navigation = namespace('navigation');

@Component({
  components: {
    LoginPanel,
    PersonalInfoPanel,
    AddressPanel,
    PaymentInfoPanel,
    InterestsPanel,
    QuestionsPanel
  }
})
export default class RegistrationPanel extends Vue {
  @navigation.Getter
  public currentTab!: NavigationTab;
}
